<div class="process-configuration">
  <h2 class="title">
    {{ 'manageVersion.configureProcess' | translate }}
  </h2>
  <ion-list line="full" mode="ios">
    <ion-item>
      <ion-label position="stacked">
        {{ 'manageVersion.versionName' | translate }} *
      </ion-label>
      <ion-input type="text"
        [placeholder]="'manageVersion.versionName' | translate"
        [(ngModel)]="configuration.title"
      ></ion-input>
    </ion-item>

    <ion-item>
      <ion-label position="stacked" >
        <h2>{{ 'manageVersion.processInstructions' | translate }}</h2>
      </ion-label>
      <ion-textarea
        [placeholder]="'manageVersion.processInstructions' | translate"
        [(ngModel)]="configuration.instructions"
      ></ion-textarea>
    </ion-item>
  </ion-list>
</div>